import React from 'react';
import hoc from './FieldHOC';

class Instructions extends React.Component {
  render() {
    return <div dangerouslySetInnerHTML={{__html: this.props.field.prop('instructions')}}></div>;
  }
}

export default hoc(Instructions);
